import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaCheck } from 'react-icons/fa';

const About = () => {
  return (
    <section id="about" className="section">
      <Container>
        <div className="section-title">
          <h2>Who We Are</h2>
        </div>
        <Row className="align-items-center">
          <Col lg={6}>
            <div className="about-content">
              <h3>Freelance Developers</h3>
              <p>
                We are a team of skilled freelance developers with expertise in various 
                technologies and domains. Our mission is to provide high-quality digital 
                solutions that help businesses grow and succeed in the digital world.
              </p>
              <p>
                With years of experience in the industry, we have worked with clients 
                from various sectors, delivering custom solutions that meet their specific needs.
              </p>
              <div className="mt-4">
                <h4>Why Choose Us</h4>
                <Row className="mt-3">
                  <Col md={6}>
                    <div className="d-flex mb-3">
                      <div className="me-3 text-primary">
                        <FaCheck />
                      </div>
                      <div>
                        <p className="mb-0"><strong>Expertise</strong> in multiple technologies</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="d-flex mb-3">
                      <div className="me-3 text-primary">
                        <FaCheck />
                      </div>
                      <div>
                        <p className="mb-0"><strong>Customized solutions</strong> for your needs</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="d-flex mb-3">
                      <div className="me-3 text-primary">
                        <FaCheck />
                      </div>
                      <div>
                        <p className="mb-0"><strong>Timely delivery</strong> of projects</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="d-flex mb-3">
                      <div className="me-3 text-primary">
                        <FaCheck />
                      </div>
                      <div>
                        <p className="mb-0"><strong>Ongoing support</strong> after completion</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div className="about-image">
              <div 
                className="img-fluid rounded shadow"
                style={{ 
                  width: '100%', 
                  height: '400px',
                  background: 'linear-gradient(135deg, #2c3e50, #3498db)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white'
                }}
              >
                <div className="text-center">
                  <h3>GDWD Team</h3>
                  <p>Freelance Developers</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
